import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Box } from "@mui/material";
import { PageHeader } from "../../components/common/PageHeader/PageHeader";
import MedicineTable from "../../components/common/Model/MedicineTable";

export const MedicinesEdit = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Edit Medicine" />
                                <MedicineTable EDIT="EDIT_MEDICiNE" deleteAccess={false}/>
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
